module.exports = __webpack_public_path__ + "img/about-top-mobile.2905a1f8.png";